import { render } from "./MyItems.vue?vue&type=template&id=3213ffa9&scoped=true&ts=true"
import script from "./MyItems.vue?vue&type=script&lang=ts"
export * from "./MyItems.vue?vue&type=script&lang=ts"

import "./MyItems.vue?vue&type=style&index=0&id=3213ffa9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3213ffa9"]])

export default __exports__